import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Async thunk to send IP info to backend
export const logIpInfo = createAsyncThunk(
  "ipLogger/logIpInfo",
  async (ipInfo, { rejectWithValue }) => {
    try {
      const response = await api.post("/add-ip-info", ipInfo, {
        withCredentials: true,
      });
      console.log("IP info logged successfully:", response.data.data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to log IP info"
      );
    }
  }
);

// Initial state
const initialState = {
  ipData: null,
  loading: false,
  error: null,
};

const ipLogger = createSlice({
  name: "ipLogger",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logIpInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logIpInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.ipData = action.payload;
      })
      .addCase(logIpInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ipLogger.reducer;
